import { createSlice } from '@reduxjs/toolkit'
import { StarPrinter } from './models/StarPrinter'
import { StarPrinters, useObjSelector } from 'utils'
import { differenceBy, intersectionBy } from 'lodash-es'

const slice = createSlice({
	name        : 'printers',
	initialState: [],
	reducers    : {
		//this is considered data linked to the device, not to the login, so there's no need to clean on logout
		setPrinters: (state, { payload: printers }) => {
			const existingPrinters = intersectionBy(state, printers, 'port') //keep the existing ones...
			const newPrinters = differenceBy(printers, existingPrinters, 'port') //find the new ones...
			return existingPrinters.concat(newPrinters) //and join them all, effectively removing disconnected printers
		},
		togglePrinter: setField('enabled'),
		setCopies: setField('copies')
	},
})

function setField(fieldName) {
	return (state, { payload }) => {
		state.filter(printer => printer.port == payload.port)[0][fieldName] = payload[fieldName]
	}
}

//not exactly official, but enough for some organization
slice.thunks = {
	//no API access either, but it's async and interacts with the state, so... thrown here as well
	searchPrinters: (showAlerts = true, callback = () => {}) => async () => {
		if (StarPrinters.isInterfaceEnabled()) {
			StarPrinters.search(slice.actions.setPrinters, showAlerts, callback)
		}
	}
}

/**
 * @param printers
 * @returns {StarPrinter[]}
 */
const getPrinters = ({ printers }) => StarPrinter.map(printers)
/**
 * @param state
 * @returns {StarPrinter[]}
 */
export const getEnabledPrinters = state => getPrinters(state).filter(p => p.enabled)
/**
 * @returns {StarPrinter[]}
 */
export const usePrinters = () => useObjSelector(getPrinters)
export const useEnabledPrinters = () => useObjSelector(getEnabledPrinters)

export const { togglePrinter, setCopies } = slice.actions
export const { searchPrinters } = slice.thunks

export default slice.reducer
